<template>
  <fade-in-out>
    <user-product-store-content-shimmer
      v-if="!display"
    />
    <form-group
      v-else
      class="pt-0"
    >
      <v-row>
        <v-col cols="12">
          <v-tabs v-model="tabs">
            <v-tab
              v-for="(tab, idx) in items"
              :key="makeKey('tab_product_store', idx, tab.value)"
            >
              {{ getTabName(tab.value) }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item
              v-for="(tab, idx) in items"
              :key="makeKey('tab_item_product_store', idx, tab.value)"
            >
              <v-col cols="12">
                <component
                  :is="tab.component"
                  v-model="storeId"
                />
              </v-col>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </form-group>
  </fade-in-out>
</template>

<script>
import FadeInOut from '@/app/arch/components/transitions/FadeInOut.vue';
import UserProductStoreContentShimmer from 'App/users/components/shimmers/UserProductStoreContentShimmer.vue';
import FormGroup from 'Arch/components/crud/components/FormGroup.vue';
import ProductCategory from '@/app/arch/enums/ProductCategory';
import {
  UserBoProductList, UserCpProductList,
  UserOtProductList, UserGiftCardList,
  UserRoProductList, UserTcProductList,
  UserTrProductList, UserTeProductList,
  UserRtProductList, UserPcProductList,
} from 'App/users/components/tables';

export default {
  name: 'UserProductStoreContent',
  components: {
    UserProductStoreContentShimmer,
    FadeInOut,
    FormGroup,
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    tabs: null,
    categories: ProductCategory,
    items: [
      {
        value: 'RECARGA_ONLINE',
        component: UserRoProductList,
      },
      {
        value: 'GIFTCARD',
        component: UserGiftCardList,
      },
      {
        value: 'RECARGA_TRANSPORTE',
        component: UserRtProductList,
      },
      {
        value: 'CHIP',
        component: UserCpProductList,
      },
      {
        value: 'BOLETO',
        component: UserBoProductList,
      },
      {
        value: 'OUTROS',
        component: UserOtProductList,
      },
      {
        value: 'TRANSFERENCIA_ENTRE_CONTA',
        component: UserTcProductList,
      },
      {
        value: 'TRANSFERENCIA',
        component: UserTrProductList,
      },
      {
        value: 'TED_TEF',
        component: UserTeProductList,
      },
      {
        value: 'PAGAMENTO_CONTA_BOLETO',
        component: UserPcProductList,
      },
    ],
  }),
  computed: {
    storeId() {
      return this.value;
    },
    isLoading() {
      return this.loading;
    },
    display() {
      return !this.loading && Number(
        this.storeId,
      ) >= 1;
    },
    getTabName() {
      return (value) => {
        const category = this.categories.find(
          (c) => c.value === value,
        );

        return category ? category.text : '';
      };
    },
  },
  methods: {
    makeKey(key, ...props) {
      let name = key;
      props.forEach(
        (prop) => {
          name += prop;
        },
      );
      return name;
    },
  },
};
</script>
